var _path, _path2, _path3;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserAdd(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.30769 21.5C1.75192 21.5 2.11538 21.1366 2.11538 20.6923C2.11538 17.5746 4.65154 15.0385 7.76923 15.0385H15.0385C15.4827 15.0385 15.8462 14.675 15.8462 14.2308C15.8462 13.7866 15.4827 13.4231 15.0385 13.4231H7.76923C3.76308 13.4231 0.5 16.6862 0.5 20.6923C0.5 21.1366 0.863462 21.5 1.30769 21.5Z",
    fill: "#20C3FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0015 11.8077C14.1192 11.8077 16.6553 9.27154 16.6553 6.15385C16.6553 3.03615 14.1192 0.5 11.0015 0.5C7.88381 0.5 5.34766 3.03615 5.34766 6.15385C5.34766 9.27154 7.88381 11.8077 11.0015 11.8077ZM11.0015 2.11538C13.2307 2.11538 15.04 3.92462 15.04 6.15385C15.04 8.38308 13.2307 10.1923 11.0015 10.1923C8.77227 10.1923 6.96304 8.38308 6.96304 6.15385C6.96304 3.92462 8.77227 2.11538 11.0015 2.11538Z",
    fill: "#20C3FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.6929 17.4615H19.0775V15.8461C19.0775 15.4019 18.7141 15.0385 18.2698 15.0385C17.8256 15.0385 17.4621 15.4019 17.4621 15.8461V17.4615H15.8468C15.4025 17.4615 15.0391 17.825 15.0391 18.2692C15.0391 18.7135 15.4025 19.0769 15.8468 19.0769H17.4621V20.6923C17.4621 21.1365 17.8256 21.5 18.2698 21.5C18.7141 21.5 19.0775 21.1365 19.0775 20.6923V19.0769H20.6929C21.1371 19.0769 21.5006 18.7135 21.5006 18.2692C21.5006 17.825 21.1371 17.4615 20.6929 17.4615Z",
    fill: "#20C3FF"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserAdd);
export default __webpack_public_path__ + "static/media/userAdd.d1fab6d5b37493f5c380ff9077e83211.svg";
export { ForwardRef as ReactComponent };